var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      staticClass: "item",
      attrs: { effect: "dark", placement: "top" },
      scopedSlots: _vm._u([
        {
          key: "content",
          fn: function() {
            return [
              _c("div", [_vm._v("按月、年统计，截止至本月25日和今年12月25日")]),
              _vm._v(" "),
              _c("div", [_vm._v("按月统计时段：上月26日~本月25日")]),
              _vm._v(" "),
              _c("div", [_vm._v("按年统计时段：去年12月26日~今年12月25日")])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c("i", {
        staticClass: "ali-icon important ali-icon-help",
        staticStyle: {
          "font-size": "16px",
          color: "#007AFF",
          "font-weight": "bold"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }